/**
 * A PESSOA DE POSTO PARCEIRO (decisão 58, 0132): gente de fora da empresa, que
 * só lança o abastecimento que fez na frota.
 *
 * Pedido do dono (30/10/2026): "preciso que o fornecedor só tenha acesso à
 * ferramenta de lançamento de combustível e que já venha preenchido seus dados
 * no posto e já selecionado externo no tanque para evitarmos erros. Esse tipo
 * de acesso deve ser bem fechado".
 *
 * A porta de verdade mora no servidor (`autorizacao/parceiro.ts`): toda rota
 * fora do lançamento responde 403. Aqui fica a OUTRA metade, a da tela: a
 * pessoa de posto não vê menu, busca nem link para tela que o servidor recusa,
 * e qualquer endereço digitado à mão volta para o lançamento. Uma tela que
 * abre e mostra "sem permissão" em cada canto ensina a pessoa a procurar a
 * porta; uma tela que só tem o lançamento não deixa dúvida.
 *
 * As listas ficam aqui, puras, para o teste conferir a regra sem desenhar a
 * casca.
 */

/** Na mesa, o lançamento completo é a casa da pessoa de posto: tem o tipo, o posto e o cupom. */
export const CASA_DO_PARCEIRO_NA_MESA = '/combustivel/lancamento/completo';

/** As únicas telas da mesa que a pessoa de posto abre: o lançamento e o próprio perfil (senha e segundo fator). */
export const TELAS_DO_PARCEIRO_NA_MESA: readonly string[] = [CASA_DO_PARCEIRO_NA_MESA, '/perfil'];

/** O rótulo do único item do menu da mesa. */
export const ROTULO_DO_LANCAMENTO_DO_PARCEIRO = 'Lançar abastecimento';

/**
 * Para onde a mesa manda a pessoa de posto que abriu `caminho`: `null` quando
 * a tela é dela, e o lançamento para todo o resto, inclusive o painel inicial.
 */
export function destinoDoParceiroNaMesa(caminho: string): typeof CASA_DO_PARCEIRO_NA_MESA | null {
  const limpo = caminho.length > 1 && caminho.endsWith('/') ? caminho.slice(0, -1) : caminho;
  return TELAS_DO_PARCEIRO_NA_MESA.includes(limpo) ? null : CASA_DO_PARCEIRO_NA_MESA;
}

/**
 * As telas do app que a pessoa de posto abre: o início (o histórico do que
 * lançou), o lançamento no posto, o perfil e a entrada. Os caminhos são os da
 * rota do app, sem o `/m` da base.
 */
export const TELAS_DO_PARCEIRO_NO_APP: readonly string[] = ['/', '/lancar/abastecimento', '/perfil', '/entrar'];

/** Para onde o app manda a pessoa de posto que abriu `caminho`: `null` quando a tela é dela, e o início para o resto. */
export function destinoDoParceiroNoApp(caminho: string): '/' | null {
  /* A base `/m` sai antes da comparação: o roteador do app já a tira, e o
     teste não depende disso. */
  const semBase = caminho === '/m' ? '/' : caminho.startsWith('/m/') ? caminho.slice(2) : caminho;
  const limpo = semBase.length > 1 && semBase.endsWith('/') ? semBase.slice(0, -1) : semBase;
  return TELAS_DO_PARCEIRO_NO_APP.includes(limpo) ? null : '/';
}

/** A frase do cabeçalho do lançamento da pessoa de posto: de quem são os lançamentos. */
export function tituloDoLancamentoDoParceiro(fornecedor: string): string {
  const nome = fornecedor.trim();
  return nome === '' ? 'Lançamentos do posto' : `Lançamentos do ${nome}`;
}
